/**
 * @generated SignedSource<<87b97ec4254589a16978ef7f32b50eb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoFocusScreen_widgetTodoOverview$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoFocusScreenListHeader_widgetTodoOverview" | "WidgetTodoOverviewListPaginated">;
  readonly " $fragmentType": "TodoFocusScreen_widgetTodoOverview";
};
export type TodoFocusScreen_widgetTodoOverview$key = {
  readonly " $data"?: TodoFocusScreen_widgetTodoOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoFocusScreen_widgetTodoOverview">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoFocusScreen_widgetTodoOverview",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoFocusScreenListHeader_widgetTodoOverview"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTodoOverviewListPaginated"
    }
  ],
  "type": "WidgetTodoOverview",
  "abstractKey": null
};

(node as any).hash = "74cedb0e69d42db24824544109b4e56c";

export default node;
